import { type SugarAttendanceGateReason } from '@app/types'
import { Alert, Button, Stack, Text } from '@mantine/core'
import { IconLock } from '@tabler/icons-react'
import Link from 'next/link'
import { type FC } from 'react'

type AttendanceGateAlertProps = {
  message: string | null
  reason: SugarAttendanceGateReason | null
}

// Fallback copy when the backend sends no message, keyed on reason so it never
// promises something the reason does not support: gate_unavailable is not
// cleared by publishing tuition rates, so it gets no call to action.
const fallbackMessages: Record<SugarAttendanceGateReason, string> = {
  gate_unavailable: 'This period is temporarily unavailable for attendance entry. Please try again shortly.',
  tuition_rates_incomplete: 'Attendance entry is locked until you submit published tuition rates for this site.'
}

export const AttendanceGateAlert: FC<AttendanceGateAlertProps> = ({ message, reason }) => (
  <Alert
    color='yellow'
    icon={<IconLock size={18} />}
    radius='lg'
    title='Attendance entry is locked'
  >
    <Stack
      align='flex-start'
      spacing='xs'
    >
      <Text size='sm'>
        {message || (reason && fallbackMessages[reason]) || 'Attendance entry is locked for this period.'}
      </Text>
      {reason === 'tuition_rates_incomplete' && (
        <Button
          color='brand-red'
          component={Link}
          href='/tuition-rates'
          variant='filled'
        >
          Go to Tuition Rates
        </Button>
      )}
    </Stack>
  </Alert>
)
